import { render, staticRenderFns } from "./NewsListYjjM.vue?vue&type=template&id=094598a6&scoped=true&"
import script from "./NewsListYjjM.vue?vue&type=script&lang=js&"
export * from "./NewsListYjjM.vue?vue&type=script&lang=js&"
import style0 from "./NewsListYjjM.vue?vue&type=style&index=0&id=094598a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "094598a6",
  null
  
)

export default component.exports